// src/features/dashboard/DashboardPage.jsx
import React from "react";
import { useAuth } from "../../hooks/useAuth";
import StudentDashboard from "./StudentDashboard";
import AdminDashboard from "./AdminDashboard";
import SuperAdminDashboard from "./SuperAdminDashboard";
import TeacherDashboard from "./TeacherDashboard";

const DashboardPage = () => {
  const { user } = useAuth();

  if (!user) {
    return (
      <p className="text-center py-10">
        You need to be logged in to view the dashboard.
      </p>
    );
  }

  if (!user.role) {
    return (
      <div className="text-center py-10">
        <h1 className="text-2xl font-bold mb-4">Hello, {user.name}</h1>
        <p className="text-lg text-red-500">
          Your account is missing a role. Please contact the admin.
        </p>
      </div>
    );
  }

  const role = user.role.toLowerCase();

  // Superadmin does not require organisation spreadsheet ID
  if (role === 'superadmin') {
    return <SuperAdminDashboard />;
  }

  // All other roles require an organisation spreadsheet ID
  if (!user.spreadsheetId) {
    return (
      <div className="text-center py-10">
        <p className="text-lg text-red-500">
          Organisation data not available. Please log out and try again.
        </p>
      </div>
    );
  }

  if (role === "admin") return <AdminDashboard />;
  if (role === "teacher") return <TeacherDashboard />;

  // Default: student dashboard
  return <StudentDashboard />;
};

export default DashboardPage;